import styled from 'styled-components';

const ListGroup = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    padding: ${({ theme }) => theme.spacing.small / 2 || '0.3125rem'};
  }
`;

export default ListGroup;
